<template>
    <div>
        <v-container fluid>
            <v-row no-gutters>
                <v-col :cols="6">
                    <h1 class="mb-3 headline font-weight-light">PROJECT</h1>
                </v-col>
                <v-col :cols="6" class="text-right"> </v-col>
            </v-row>

            <v-dialog v-model="dialog" max-width="1000px">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <!-- <v-col cols="12" sm="6" md="4">
                                    <v-text-field
                                        v-model="editedItem.team"
                                        label="Team"
                                    ></v-text-field>
                                </v-col> -->

                                <v-col cols="12" sm="6" md="4">
                                    <v-select
                                        v-model="editedItem.team"
                                        :items="team"
                                        item-text="team_name"
                                        item-value="team_id"
                                        menu-props="auto"
                                        label="Team"
                                        hide-details
                                        single-line
                                    ></v-select>
                                </v-col>

                                <v-col cols="12" sm="6" md="4">
                                    <v-select
                                        v-model="editedItem.partner_id"
                                        :items="partners"
                                        item-text="partner_name"
                                        item-value="partner_id"
                                        menu-props="auto"
                                        label="Partner"
                                        hide-details
                                        single-line
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field
                                        v-model="editedItem.project_name"
                                        label="Project Name"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field
                                        v-model="editedItem.project_name_wms"
                                        label="Project Name WMS"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-switch
                                        v-model="editedItem.is_wms"
                                        label="Is WMS"
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-switch
                                        v-model="editedItem.status"
                                        label="Status"
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12" sm="6" md="8">
                                    <v-select
                                        v-model="problem_group"
                                        :items="problemgroup"
                                        item-text="problem_group_name"
                                        item-value="problem_group_id"
                                        :value="problem_group.problem_group_id"
                                        menu-props="auto"
                                        label="Problem Group"
                                        hide-details
                                        multiple
                                        chips
                                        single-line
                                    ></v-select>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close"
                            >Cancel</v-btn
                        >
                        <v-btn color="blue darken-1" text @click="save"
                            >Save</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-card>
                <v-card-title>
                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search"
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" dark class="mb-2" @click="newItem()"
                        >Create New</v-btn
                    >
                </v-card-title>
                <v-data-table
                    :headers="headers"
                    :items="this.data"
                    :items-per-page="10"
                    :loading="isLoading"
                    :search="search"
                    loading-text="Loading... Please wait"
                >
                    <template v-slot:item.project_name_wms="{ item }">
                        <span class="primary--text font-weight-medium">{{ item.project_name_wms }}</span>
                    </template>
                    <template v-slot:item.is_wms="{ item }">
                        {{ item.is_wms == "Y" ? "Active" : "Not Active" }}
                    </template>
                    <template v-slot:item.status="{ item }">
                        {{ item.status == 1 ? "Active" : "Not Active" }}
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-icon small class="mr-2" @click="editItem(item)">
                            mdi-square-edit-outline
                        </v-icon>
                        <v-icon small @click="deleteItem(item)">
                            mdi-delete
                        </v-icon>
                    </template>
                </v-data-table>
            </v-card>
            <div id="snackbar">
                <v-snackbar v-model="snackbar" color="success" right>
                    {{ text }}
                </v-snackbar>
            </div>
        </v-container>
    </div>
</template>

<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"

export default {
    computed: {
        ...mapState(["isLoading"]),
        ...mapState(["snackbar"]),
        formTitle() {
            return this.editedIndex === -1 ? "New Project" : "Edit Project"
        },
    },
    mounted() {
        this.getAjax()
        this.getPartner()
        this.getTeam()
    },
    data() {
        return {
            search: "",
            data: [],
            partners: [],
            problem_group: [],
            problemgroup: [],
            team: [],
            dialog: false,
            editedIndex: -1,
            editedItem: {
                team: "",
                project_name: "",
                project_name_wms: "",
                status: "",
                partner_id: "",
                is_wms: false,
            },
            defaultItem: {
                team: "",
                project_name: "",
                project_name_wms: "",
                status: "",
                partner_id: "",
                is_wms: false,
            },
            headers: [
                {
                    text: "team",
                    value: "team_name",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "Company",
                    value: "company",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "partner name",
                    value: "partner_name",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "project name",
                    value: "project_name",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "project wms",
                    value: "project_name_wms",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "Is WMS",
                    value: "is_wms",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "status",
                    value: "status",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "Actions",
                    value: "action",
                    class: "text-uppercase blue darken-3 white--text",
                    sortable: false,
                },
            ],
            text: "Success, Your work has been saved",
        }
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        ...mapMutations(["mutatesnackbar"]),
        resetEdited() {
            this.editedItem = { ...this.defaultItem }
            this.editedIndex = -1
        },
        newItem() {
            this.resetEdited()
            this.dialog = true
        },
        editItem(item) {
            this.editedIndex = item.project_id
            this.editedItem = Object.assign({}, item)
            this.editedItem.status = item.status == 1 ? true : false
            this.editedItem.is_wms = item.is_wms == "Y" ? true : false
            this.dialog = true

            this.problem_group = item.problem_group.map((each) => {
                return each.problem_group_id
            })
        },
        async deleteItem(item) {
            const idx = item.project_id
            if (confirm("Are you sure you want to delete this project?")) {
                const url = `${process.env.VUE_APP_ROOT_API}/api/projects`
                try {
                    const { data } = await axios.delete(url + "/" + idx)
                } catch (error) {
                    console.log(error)
                }
                this.getAjax()
            }
        },
        close() {
            this.dialog = false
            setTimeout(() => {
                this.resetEdited()
            }, 300)
        },
        save() {
            this.mutatesnackbar()
            this.editedItem.status = this.editedItem.status === true ? 1 : 0
            this.editedItem.is_wms = this.editedItem.is_wms === true ? "Y" : "N"
            this.editedItem.problem_group = this.problem_group

            this.sendAjax(this.editedItem, this.editedIndex)
            this.close()
            if (this.snackbar === true) {
                setTimeout(() => {
                    this.mutatesnackbar()
                    this.snackbar
                }, 2000)
            }
        },
        async sendAjax(item, idx) {
            const url = `${process.env.VUE_APP_ROOT_API}/api/projects`
            if (idx > -1) {
                try {
                    const { data } = await axios.put(
                        url + "/" + this.editedIndex,
                        item
                    )
                } catch (error) {
                    console.log(error)
                }
            } else {
                try {
                    const { data } = await axios.post(url, item)
                } catch (error) {
                    console.log(error)
                }
            }
            this.getAjax()
        },
        async getAjax() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/projects`
            try {
                this.mutateIsLoading()
                const { data } = await axios.get(url)
                this.data = data
                this.mutateIsLoading()
            } catch (error) {
                console.log(error)
            }
        },
        async getPartner() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/form-project`
            try {
                this.mutateIsLoading()
                const { data } = await axios.get(url)
                this.partners = data.partners
                this.problemgroup = data.problem_group
                this.team = data.team
                this.mutateIsLoading()
            } catch (error) {
                console.log(error)
            }
        },
    },
}
</script>
